import { literal, TypeOf } from 'zod';

import { BaseProduct } from './base';
import { ProductType } from './types';

/* ----------------------------- Channel Product ---------------------------- */

export const ChannelProduct = BaseProduct.extend({
    type: literal(ProductType.Channel),
});
export type ChannelProduct = TypeOf<typeof ChannelProduct>;
